import React, { useState } from "react";
import { motion } from "framer-motion";
import { useLocaleContext } from "../../../../context/LocaleContext";
import { useShopContext } from "../../../../context/ShopContext";
import { getBalancePointsString } from "../../../../helpers/prizes-shop";
import ShopOrder from "../../../../blocks/PrizeShopBlock/ShopOrder";
import CPaginator from "../../../UI/CPaginator";
import LoadingMessage from "../../../LoadingMessage";

import "./style.scss";

const ORDERS_PER_PAGE = 4;

const UserProfileBalance = () => {
    const $locale = useLocaleContext();
    const { userBalance, orders, prizes } = useShopContext();
    const [page, setPage] = useState(0);

    const totalPrizesPerPersonCount = prizes.reduce((acc, prize) => acc + prize.limitPerPerson, 0);

    const blockConfigInitial = {
        visibility: 'hidden',
        display: 'none',
        opacity: 0,
    };

    const blockConfigAnimate = {
        visibility: 'visible',
        display: 'block',
        opacity: 1,
    };

    const blockTransition = {
        ease: 'linear',
        duration: .7,
    };

    return (
        <div className="user-profile-balance page-block">
            {userBalance === null
                ? <LoadingMessage isPreloader />
                : <motion.div
                    initial={blockConfigInitial}
                    animate={blockConfigAnimate}
                    transition={blockTransition}
                >
                    <h2 className="user-profile-balance__title">
                        {$locale.get('shop.balance')} {getBalancePointsString({$locale, price: userBalance || 0})}
                    </h2>
                    <div className="user-profile-balance__orders">
                        <div className="user-profile-balance__orders-header">
                            <h3 className="user-profile-balance__orders-title">
                                {$locale.get('shop.myPrizes')}
                            </h3>
                            <span>
                                {orders.length} / {totalPrizesPerPersonCount}
                            </span>
                        </div>
                        {orders.length ?
                            <div className="user-profile-balance__orders-list scrollable">
                                {orders.slice(page * ORDERS_PER_PAGE, page * ORDERS_PER_PAGE + ORDERS_PER_PAGE).map((order) => (
                                    <ShopOrder
                                        key={order.id}
                                        $locale={$locale}
                                        prize={order.product}
                                    />
                                ))}
                            </div>
                            : <p>{$locale.get('shop.myPrizes.empty')}</p>
                        }
                    </div>
                    {orders.length > ORDERS_PER_PAGE &&
                        <CPaginator
                            currentPage={page}
                            perPage={ORDERS_PER_PAGE}
                            total={orders.length}
                            onChangePage={page => setPage(page)}
                        />
                    }
                </motion.div>
            }
        </div>
    );
};

export default UserProfileBalance;
